<template>
  <component v-if="status" id="modal" :is="name" />
</template>

<script>
import commonBox from './commonBox'
import { mapState } from 'vuex'

export default {
  name: 'modal',
  data() {
    return {}
  },
  components: {
    commonBox: commonBox
  },
  computed: {
    ...mapState({
      status: state => state.modal.status,
      name: state => state.modal.name
    }),
    getModalShow() {
      return this.$store.state.modal.status
    }
  },
  watch: {
    getModalShow: function(val) {
      const bodyEl = document.querySelector('body')
      if (val === true) {
        bodyEl.classList.add('hidden-scroll')
        // 光箱開啟 設定body背景
        const scrollY = document.documentElement.style.getPropertyValue('--scroll-y')
        bodyEl.style.position = 'fixed'
        bodyEl.style.top = `-${scrollY}`
      } else {
        bodyEl.classList.remove('hidden-scroll')
        // 光箱關閉 設定body背景
        const scrollY = bodyEl.style.top
        bodyEl.style.position = ''
        bodyEl.style.top = ''
        window.scrollTo(0, parseInt(scrollY || '0') * -1)
      }
    }
  },
  created() {
    window.addEventListener('scroll', function() {
      document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`)
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', function() {})
  }
}
</script>

<style scoped>
.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
